import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../config/firebase';

export function useRequestPrice() {
  const [price, setPrice] = useState(500);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onSnapshot(doc(db, 'settings', 'requestPrice'), 
      (doc) => {
        if (doc.exists()) {
          setPrice(doc.data().amount);
        }
        setLoading(false);
      },
      (error) => {
        console.error('Error fetching request price:', error);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  return { price, loading };
} 